$(function() {

    $('#leftBarMiddle .closeMenu').click(function() {
        $('#leftBarMiddle .wrapSubmenu').hide();

        $('#leftBarMiddle .icones .menu').removeClass('actif inactif');

        $('.submenu').hide();
    });

    $('#leftBarMiddle .icones .menu').click(function() {

        var id = $(this).attr('id');

        $('#leftBarMiddle .wrapSubmenu').css("display", "flex").hide().fadeIn();

        $('#leftBarMiddle .icones .menu:not(#' + id + ')').addClass('inactif');
        $(this).removeClass('inactif').addClass('actif');

        $('.submenu[data-menu=' + id + ']').fadeIn(300);

    });

});